/**
 * Blog article prose: find "Get started"/"Get your formula" links in authored
 * content and style them as pill CTAs labelled "See My Formula Free", pointing
 * at the funnel on go.tailored-health.com. Links authored against the retired
 * /labs-get-started are upgraded too.
 * Scope: [data-th-article-prose] (sections/th-article.liquid).
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-th-article-prose]';
  var LABEL_RE = /^(get started|get your formula)$/i;
  var CTA_LABEL = 'See My Formula Free';
  var FUNNEL_URL = 'https://go.tailored-health.com/start';
  var LEGACY_FUNNEL_PATH = '/labs-get-started';
  var ARROW_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
    '<path d="M7 17L17 7M9 7h8v8" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  function pathname(href) {
    if (!href) return '';
    try {
      return new URL(href, window.location.origin).pathname.replace(/\/$/, '') || '/';
    } catch (e) {
      return href.split('?')[0].split('#')[0].replace(/\/$/, '');
    }
  }

  function isFunnelOrLegacyTarget(href, configuredPath) {
    var path = pathname(href);
    if (!path) return false;
    if (configuredPath && path === configuredPath) return true;
    if (path === LEGACY_FUNNEL_PATH || path.indexOf(LEGACY_FUNNEL_PATH) !== -1) return true;
    if (path.indexOf('/products/base-personalized-supplement') !== -1) return true;
    return false;
  }

  function upgradeProse(root) {
    if (!root || root.__thArticleCtaInit) return;
    root.__thArticleCtaInit = true;

    var configuredPath = pathname(root.getAttribute('data-th-get-started-href') || '');

    root.querySelectorAll('a[href]').forEach(function (anchor) {
      if (anchor.classList.contains('button')) return;
      if (!LABEL_RE.test(anchor.textContent.trim())) return;
      if (!isFunnelOrLegacyTarget(anchor.getAttribute('href'), configuredPath)) return;
      anchor.setAttribute('href', root.getAttribute('data-th-get-started-href') || FUNNEL_URL);
      anchor.classList.add('button', 'button--primary', 'th-article__cta');
      anchor.textContent = '';
      var span = document.createElement('span');
      span.textContent = CTA_LABEL;
      anchor.appendChild(span);
      anchor.insertAdjacentHTML('beforeend', ARROW_SVG);
    });
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(upgradeProse);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector(ROOT_SELECTOR);
    if (!root) return;
    delete root.__thArticleCtaInit;
    upgradeProse(root);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
